module.exports = __webpack_public_path__ + "static/media/professional.dfcc6396.png";